import React from 'react'
import { motion } from 'framer-motion'

export const letterVariants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { opacity: { duration: 0 } } },
}

interface ITypewriterProps {
  text: string
  speed?: number
  delay?: number
}

export const Typewriter: React.FC<ITypewriterProps> = ({
  text,
  speed = 0.05,
  delay = 0,
  ...rest
}) => (
  <motion.p
    key={text}
    variants={{
      hidden: {},
      visible: {
        opacity: 1,
        transition: { staggerChildren: speed, delayChildren: delay },
      },
    }}
    initial="hidden"
    animate="visible"
    transition={{ delay }}
    {...rest}
  >
    {text.split('').map((char, i) => (
      <motion.span key={`${char}-${i}`} variants={letterVariants}>
        {char}
      </motion.span>
    ))}
  </motion.p>
)
